import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {PricingPlanSchema} from './pricingPlan'

export const PricingOptionSchema = buildEntrySchemaFor('pricingOption', {
  fields: z.lazy(() =>
    z.object({
      label: z.string(),
      plans: z.array(PricingPlanSchema),
      mostPopular: safeOptional(z.number().int()),
    }),
  ),
})

export type PricingOption = z.infer<typeof PricingOptionSchema>
